import { createApp } from 'vue'
import App from './App.vue'
import {Preview} from "@cupshe/low-code-preview/main.cjs.js"
import "@cupshe/low-code-preview/style.css"
import Antd from 'ant-design-vue';
import 'ant-design-vue/lib/grid/style/index.css';

const app = createApp(App)

app.component(Preview.name, Preview)
app.use(Antd);

app.mount('#app')
